import React, { useEffect } from "react";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Select, MenuItem, FormControl } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUserAndGameContext } from "../../../contexts/UserAndGameContext";

const IntervalDropdown = ({
        interval,
        setInterval,
        firstInterval,
        lastInterval,
        theCurrentInterval,
        intervalInfo,
        includeOverall = false,
    }) => {
        const theme = useTheme();
        const isMobile = useMediaQuery(theme.breakpoints.down('md'));
        const location = useLocation();
        const navigate = useNavigate();

        // Generate dropdown options from firstInterval to theCurrentInterval
        const generateDropdownOptions = () => {
            const options = [];
            
            if (includeOverall) {
                options.push(
                    <MenuItem key="overall" value="Overall">
                        Overall
                    </MenuItem>
                );
            }
            
            // Make sure we have intervalInfo and it has info array
            if (intervalInfo && intervalInfo.info && Array.isArray(intervalInfo.info)) {
                // Loop from firstInterval to min(theCurrentInterval, lastInterval)
                const maxInterval = Math.min(theCurrentInterval, lastInterval);
                
                for (let i = firstInterval; i <= maxInterval; i++) {
                    // Find the interval data in intervalInfo
                    const intervalData = intervalInfo.info.find(info => info.interval === i);
                    
                    if (intervalData) {
                        options.push(
                            <MenuItem key={i} value={i.toString()}>
                                {intervalData.label}
                            </MenuItem>
                        );
                    }
                }
            }
            
            return options;
        };

        const handleChange = (event) => {
            const value = event.target.value;
            setInterval(value);
            
            // Update URL with new interval
            const searchParams = new URLSearchParams(location.search);
            searchParams.set('interval', value);
            
            // Navigate to the same path but with updated query params
            navigate({
                pathname: location.pathname,
                search: searchParams.toString()
            }, { replace: true }); 
        };

        return (
            <FormControl variant="outlined" size={isMobile ? "small" : "medium"} sx={{ minWidth: 200, marginTop: '16px', marginBottom: '16px' }}>
                <Select
                    value={interval}
                    onChange={handleChange}
                    displayEmpty
                    sx={{
                        backgroundColor: 'white',
                        '& .MuiSelect-select': {
                            fontWeight: 500
                        }
                    }}
                >
                    {generateDropdownOptions()}
                </Select>
            </FormControl>
        );
};

export default IntervalDropdown;